import { render, staticRenderFns } from "./EodbIndustryDetails.vue?vue&type=template&id=52a851dd&scoped=true&"
import script from "./EodbIndustryDetails.vue?vue&type=script&lang=js&"
export * from "./EodbIndustryDetails.vue?vue&type=script&lang=js&"
import style0 from "./EodbIndustryDetails.vue?vue&type=style&index=0&id=52a851dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a851dd",
  null
  
)

export default component.exports